import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useHover, useActive } from 'react-native-web-hooks';
import styled from 'styled-components/native';
import Text from '../text';
import Spacer from '../spacer';
import Colors from '../colors';
import Icon from '../icon';
const StyledPressable = styled.Pressable`
  justify-content: center;
`;
const color = {
  icon: Colors.mint400,
  iconHover: Colors.mint500,
  iconActive: Colors.mint600,
  text: Colors.gray600
};
export default function VerticalBtn(props) {
  const ref = useRef();
  const isHovered = useHover(ref);
  const isActive = useActive(ref);
  const StyledIcon = props.iconFamily;
  return /*#__PURE__*/React.createElement(StyledPressable, {
    style: [styles.button, props.disabled && styles.disabled],
    ref: ref,
    disabled: props.disabled,
    onPress: props.onPress
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    color: isActive && !props.disabled ? color.iconActive : isHovered && !props.disabled ? color.iconHover : color.icon,
    name: props.icon,
    size: 32
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodyBase, {
    weight: "medium",
    color: color.text,
    style: styles.textHeight
  }, props.children));
}
VerticalBtn.propTypes = {
  icon: PropTypes.string,
  iconFamily: PropTypes.elementType,
  disabled: PropTypes.bool,
  onPress: PropTypes.func,
  children: PropTypes.string
};
VerticalBtn.defaultProps = {
  icon: '',
  iconFamily: Icon.MaterialIcons,
  disabled: false,
  onPress: () => {},
  children: ''
};
const styles = {
  button: {
    alignItems: 'center'
  },
  disabled: {
    opacity: 0.4
  },
  textHeight: {
    lineHeight: 25.6
  }
};
//# sourceMappingURL=vertical.js.map